import Spinner from "../../Spinner.jsx";
import UserDropdownProjectItem from "./UserDropdownProjectItem.jsx";
import {useTranslation} from "react-i18next";
import {useContext} from "react";
import {GlobalContext} from "../../../utils/context/GlobalContextProvider.jsx";
import {useNavigate} from "react-router-dom";
import ProjectListCreateLink from "./ProjectListCreateLink.jsx";

export default function UserDropdownProjectList() {
    let {context, setCurrentProjectId} = useContext(GlobalContext);

    /** @var {UserDropdownProjectItem[]} */
    let displayedProjects = [];

    if (context.currentProjectId) {
        context.currentUserProjects.map((project) => {
            if (project.id === context.currentProjectId) {
                displayedProjects.push(
                    <UserDropdownProjectItem
                        key={project.id}
                        project={project}
                        isCurrent={true}
                        currentProjectId={context.currentProjectId}
                        setCurrentProjectId={setCurrentProjectId}
                    />
                );
            }
        });
    }

    context.currentUserProjects.map((project) => {
        if (displayedProjects.length < 5 && project.id !== context.currentProjectId) {
            displayedProjects.push(
                <UserDropdownProjectItem
                    key={project.id}
                    project={project}
                    isCurrent={false}
                    currentProjectId={context.currentProjectId}
                    setCurrentProjectId={setCurrentProjectId}
                />
            );
        }
    });

    return (
        <ul className="py-2 border-b border-slate-200 dark:border-slate-700">
            {!context.currentUserProjectsLoaded && <Spinner className={"mx-auto"}/>}
            {context.currentUserProjectsLoaded && displayedProjects}

            {
                context.currentUserProjects.length > displayedProjects.length
                && <ProjectListSettingsLink
                    moreAmount={context.currentUserProjects.length - displayedProjects.length}
                />
            }

            {
                context.currentUserProjects.length === 0
                && <ProjectListCreateLink/>
            }
        </ul>
    );
}

function ProjectListSettingsLink({moreAmount}) {
    let {t} = useTranslation();

    let navigate = useNavigate();

    return (
        <li className="
            text-slate-500 hover:text-slate-600 dark:hover:text-slate-400
            dark:text-gray-400 dark:hover:text-gray-300
            flex text-sm justify-center py-1 px-3 cursor-pointer
            "
            onClick={() => {
                navigate('/projects');
            }}
        >
            {t('projects.and-x-more', {count: moreAmount})}
        </li>
    );


}
